interface Kpi {
  label: string;
  value: number | string;
  sub: string;
  warn?: boolean;
  /** When set, the value is placeholder pending the named backend work. */
  mockedPending?: string;
}

interface UsersKpiStripProps {
  items: Kpi[];
}

/** Four-up KPI strip across the top of the Users page. */
export default function UsersKpiStrip({ items }: UsersKpiStripProps) {
  return (
    <div className="grid grid-cols-4 bg-white dark:bg-[#1a1f1c] rounded-xl border border-stone-200 dark:border-stone-800 overflow-hidden flex-none">
      {items.map((k, i) => (
        <div
          key={k.label}
          className={`px-[18px] py-4 flex flex-col justify-center ${i < items.length - 1 ? ' border-r border-stone-200 dark:border-stone-800' : ''}`}
        >
          <div className="text-[10px] font-semibold tracking-[.08em] uppercase text-stone-500 dark:text-stone-400">
            {k.label}
          </div>
          <div
            className={`text-2xl font-bold tracking-[-.02em] mt-0.5 tabular-nums flex items-baseline gap-1 ${
              k.warn ? 'text-clay-600' : 'text-bark-900 dark:text-[#e8ece9]'
            }`}
          >
            {k.value}
            {k.mockedPending && (
              <span
                title={`Mocked — pending backend: ${k.mockedPending}`}
                className="text-[8.5px] font-bold tracking-wider uppercase text-clay-500"
              >
                mock
              </span>
            )}
          </div>
          <div className="text-[10.5px] text-stone-500 dark:text-stone-400 mt-px">{k.sub}</div>
        </div>
      ))}
    </div>
  );
}
